import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ModalController, ToastController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import { CargandoPage } from '../cargando/cargando';

/**
 * Generated class for the CrearProyeccionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-crear-proyeccion',
  templateUrl: 'crear-proyeccion.html',
})
export class CrearProyeccionPage {
  form: any = {
    co_ven: "",
    ven_des: "",
    vendedor: "",
    monto: 0
  }
  selectOptionsVendedor: any = {
    title: 'Vendedores',
  }
  vendedores: any = []
  edit = false
  modl: any
  constructor(
    public navCtrl: NavController,
    public modal : ModalController,
    public toastCtrl: ToastController,
    public http: HttpProvider,
    public alrtCtrl : AlertController,
    public navParams: NavParams
    ) {
  }

  ionViewDidLoad() {
    this.modl = this.modal.create(CargandoPage)
    this.modl.present()
    if(window.localStorage.getItem('network') === '1') {
      this.http.get("vendedor/allProyec?vendedores="+window.localStorage.getItem('vendedores')).subscribe((res:any) =>{
        this.vendedores = res
        if (this.navParams.get('value')) {
          this.edit = true
          let info = this.navParams.get('value')
          this.form._id = info._id
          this.form.co_ven = info.co_ven
          this.form.ven_des = info.ven_des
          this.form.monto = info.monto
          this.vendedores.forEach(el=>{
            if (el.co_ven.trim() == this.form.co_ven.trim()) this.form.vendedor = el
          })
        }
        if(!this.edit) {
          this.vendedores = this.vendedores.filter(el=>{
            return el.proyeccion === 0
          })
        }
        this.modl.dismiss()
      }, err=>{
        console.log(err)
        this.toastCtrl.create({
          duration: 4000,
          message:'Error al traer la información, intente de nuevo o llame al administrador.'
        }).present()
        this.modl.dismiss()
      })
    } else {
      this.alrtCtrl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

  advertencia() {
    this.alrtCtrl.create({
      title: '¿Estás seguro?',
      subTitle:'No podrás revertir esta operación!',
      buttons:[
        {
          text:'Cancelar',
          cssClass:'btn'
        },
        {
          text:'Aceptar',
          cssClass:'btnAceptar',
          handler:()=>{
            this.registrar()
          }
        }
      ]
    }).present()
  }

  registrar() {
    if(window.localStorage.getItem('network') === '1') {
      if (this.form.vendedor && this.form.monto) {
        this.form.co_ven = this.form.vendedor.co_ven
        this.vendedores.forEach(el=>{
          if (el.co_ven.trim() === this.form.co_ven.trim()) {
            this.form.ven_des = el.ven_des
          }
        })
        this.modl.present()
        if (!this.edit) {
          this.http.post('proyeccion', this.form).subscribe((res:any) => {
            this.modl.dismiss()
            if(res.status === 'denied'){
              this.alrtCtrl.create({
                title: 'Atención',
                subTitle: res.message,
                buttons:[
                  {
                    text:'Aceptar',
                    cssClass:'btnAceptar',
                    handler:()=>{
                    }
                  }
                ]
              }).present()
            }else{
              this.alrtCtrl.create({
                title: 'Felicidades',
                subTitle: 'Registro realizado exitosamente.',
                buttons:[
                  {
                    text:'Aceptar',
                    cssClass:'btnAceptar',
                    handler:()=>{
                      this.navCtrl.getPrevious().data.act = "Si";
                      this.navCtrl.pop()
                    }
                  }
                ]
              }).present()
            }
          }, err=> {
            console.log(err)
            this.modl.dismiss()
            this.alrtCtrl.create({
              title: 'Atención',
              subTitle: 'Error de conexión, intente nuevamente o contacte con el administrador.',
              buttons:[
                {
                  text:'Aceptar',
                  cssClass:'btnAceptar',
                  handler:()=>{
                  }
                }
              ]
            }).present()
          })
        } else {
          this.http.put('proyeccion', this.form).subscribe((res:any) => {
            this.modl.dismiss()
            if(res.status === 'denied'){
              this.alrtCtrl.create({
                title: 'Atención',
                subTitle: res.message,
                buttons:[
                  {
                    text:'Aceptar',
                    cssClass:'btnAceptar',
                    handler:()=>{
                    }
                  }
                ]
              }).present()
            }else{
              this.alrtCtrl.create({
                title: 'Felicidades',
                subTitle: 'Modificación realizado exitosamente.',
                buttons:[
                  {
                    text:'Aceptar',
                    cssClass:'btnAceptar',
                    handler:()=>{
                      this.navCtrl.getPrevious().data.act = "Si";
                      this.navCtrl.pop()
                    }
                  }
                ]
              }).present()
            }
          }, err=> {
            console.log(err)
            this.modl.dismiss()
            this.alrtCtrl.create({
              title: 'Atención',
              subTitle: 'Error de conexión, intente nuevamente o contacte con el administrador.',
              buttons:[
                {
                  text:'Aceptar',
                  cssClass:'btnAceptar',
                  handler:()=>{
                  }
                }
              ]
            }).present()
          })
        }
      } else {
        this.alrtCtrl.create({
          title: 'Atención',
          subTitle: 'Debe ingresar los campos correspondientes.',
          buttons:[
            {
              text:'Aceptar',
              cssClass:'btnAceptar',
              handler:()=>{
              }
            }
          ]
        }).present()
      }
    } else {
      this.alrtCtrl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/crear-proyeccion/crear-proyeccion.ts